// src/App.js

import React, { useState } from 'react';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import InventoryPage from './pages/InventoryPage';
import DemandPage from './pages/DemandPage';
import PricingPage from './pages/PricingPage';
import OrchestrationPage from './pages/OrchestrationPage';
import ConfigPage from './pages/ConfigPage';
import AgentsPage from './pages/AgentsPage';

export default function App() {
  const [page, setPage] = useState(localStorage.getItem('token') ? 'dashboard' : 'login');

  // Background image mapping for each page
  const bgImages = {
    login: 'login-bg.jpg',
    register: 'register-bg.jpg',
    dashboard: 'dashboard-bg.jpg',
    inventory: 'inventory-bg.jpg',
    demand: 'demand-bg.jpg',
    pricing: 'inventory-bg.jpg', // Corrected background image name for pricing page
    orchestration: 'orchestration-bg.jpg',
    config: 'orchestration-bg.jpg', // Specific background image for the config page
    agents: 'inventory-bg.jpg'  // Added for agents page if needed
  };

  // Get the background image for the current page
  const bg = bgImages[page] || 'default-bg.jpg'; // Fallback to default-bg.jpg if no match

  return (
    <div
      className="container-bg"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/images/${bg})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover', // Ensures the image covers the whole container
        backgroundPosition: 'center',
        minHeight: '100vh', // Ensures the container is at least 100vh but can grow
        display: 'flex', // Ensures the page content is centered
        flexDirection: 'column', // Align content vertically
        justifyContent: 'flex-start', // Start at the top, not center
        overflowY: 'auto', // Enables vertical scrolling if content overflows
      }}
    >
      {/* Conditional rendering of the current page */}
      {page === 'login' && <Login setPage={setPage} />}
      {page === 'register' && <Register setPage={setPage} />}
      {page === 'dashboard' && <Dashboard setPage={setPage} />}
      {page === 'inventory' && <InventoryPage setPage={setPage} />}
      {page === 'demand' && <DemandPage setPage={setPage} />}
      {page === 'pricing' && <PricingPage setPage={setPage} />}
      {page === 'orchestration' && <OrchestrationPage setPage={setPage} />}
      {page === 'config' && <ConfigPage setPage={setPage} />}
      {page === 'agents' && <AgentsPage setPage={setPage} />}
    </div>
  );
}
